/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import _ from "lodash";
import { VApplication } from "../application";

import { GET_MY_PROFILE } from "../pages/Dashboard/graphql/get-myProfile.query";
import {MENU_ITEMS} from "./test-data/dashboard-menu";

const is = require("is_js");

const MODULE_NAME = "MyProfileService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class MyProfileService {
    private static instance: MyProfileService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): MyProfileService {
        if (!MyProfileService.instance) {
            MyProfileService.instance = new MyProfileService(props);
        }
        return MyProfileService.instance;
    }

    async getMyProfile() {
        // const storageService = this.vapp.getSync("services.StorageModule");
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_MY_PROFILE,
                    fetchPolicy: 'network-only'
                });
                log.success(MODULE_NAME, "my profile data:", res);
                if(res?.data){
                    // storageService.set("userType", {value:"individual"}, "session");
                    return res?.data;
                }
                
            }
            
            // return true;

        } catch (err: any) {
            return err;
        }
    }

}